import { types } from "../../types/types";

const initialState = {
  paymentMethodsBillingR: []
}

export const PaymentMethodsBillingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.paymentMethodsBillingStartLoading:
      return{
        ...state,
        paymentMethodsBillingR: [ ...action.payload ]
      }
      
    default:
      return state;
  }
}
